<script lang="ts" setup>
	import {storeToRefs} from 'pinia';
	import {useAppStore} from '@/store/app.store';
	import {useSubstituteStore} from '@/store/substitutes.store';
	import SubstituteComponent from '@/components/substitute/SubstituteComponent.vue';

	const {substituteModalActive} = storeToRefs(useAppStore());
	const {substituteWeek, substituteYear, substitutes} = storeToRefs(useSubstituteStore());
</script>

<template>
	<Teleport to=".catalog-body">
		<div v-if="substituteModalActive" class="catalog-substitute-modal">
			<div class="catalog-substitute-modal__inner">
				<div class="catalog-modal">

					<template v-if="substitutes?.length > 0">
						<div class="product-overview-substitute--info">
							<h3>
								{{ $t('site.products.overview.substitutes.header.text') }}
								{{ substituteWeek }} - {{ substituteYear }}
							</h3>

							<p style="font-size: 14px;">{{ $t('site.products.overview.substitutes.info.text') }}</p>
						</div>

						<div class="substitutes--wrapper">
							<SubstituteComponent v-for="substitute in substitutes"
							                     :key="substitute.id"
							                     :substitute="substitute"
							                     :week="substituteWeek!"
							                     :year="substituteYear!" />
						</div>
					</template>

					<div v-else class="product-overview-substitute--info">
						<h3>{{ $t('site.products.overview.no-substitutes.header.text') }}</h3>
					</div>

				</div>

				<div class="catalog-modal catalog-modal__button_bar">
					<button class="button button--white button--small"
					        type="button"
					        @click.prevent="substituteModalActive = false">
						{{ $t('site.products.overview.substitutes.button.text') }}
					</button>
				</div>
			</div>
		</div>
	</Teleport>
</template>
